import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import { useResponsive } from '../../hooks/useResponsive';
import { HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE } from '../Header/headerConstants';
import { Image } from '../Image/Image';

export interface NotFoundLayoutProps {
  imageSrc: string;
  title: string;
  description: string;
  width?: string;
  withLayout?: boolean;
  linkTo?: () => void;
  buttonText?: string;
}

export const NotFoundLayout = ({
  imageSrc,
  title,
  description,
  width,
  withLayout,
  linkTo,
  buttonText,
}: NotFoundLayoutProps) => {
  const isDesktop = useResponsive('up', 'lg');

  const headerHeight = isDesktop ? HEADER_HEIGHT_DESKTOP : HEADER_HEIGHT_MOBILE;
  const layoutPadding = headerHeight + 48 * 2;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{
        height: withLayout ? `calc(100vh - ${headerHeight + layoutPadding}px)` : '100vh',
      }}
      justifyContent="center"
    >
      <Image src={imageSrc} sx={{ maxWidth: width }} />
      <Typography variant="h1" mt={4} mb={isDesktop ? 8 : 3}>
        {title}
      </Typography>
      <Typography variant="text1">{description}</Typography>
      {buttonText && (
        <Button sx={{ marginTop: 12 }} onClick={linkTo} size="large">
          {buttonText}
        </Button>
      )}
    </Box>
  );
};
